module.exports = __webpack_public_path__ + "img/Frame 2137_copy1.bce56262.png";